import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TrustCenterFacadeService } from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-automatic-approvals',
  templateUrl: './automatic-approvals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomaticApprovalsComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex w-full flex-col gap-2 text-base';

  hasAutomaticApprovals: boolean;

  constructor(
    private readonly trustCenterFacade: TrustCenterFacadeService,
    private readonly cd: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.hasAutomaticApprovals = await firstValueFrom(this.trustCenterFacade.hasAutomaticApprovals());
    this.cd.detectChanges();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.settings.automations.automaticApprovals.${key}`;
  }

  async updateAutomaticApprovalsFlag(hasAutomaticApprovals: boolean): Promise<void> {
    const previousValue = this.hasAutomaticApprovals;
    this.hasAutomaticApprovals = hasAutomaticApprovals;
    this.cd.detectChanges();

    try {
      await this.trustCenterFacade.updateSettings({ auto_approve_domains: hasAutomaticApprovals });
    } catch {
      this.hasAutomaticApprovals = previousValue;
      this.cd.detectChanges();
    }
  }
}
